(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/dimmer/views/dimmer.js') >= 0) return;  svs.modules.push('/components/components/dimmer/views/dimmer.js'); (function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_cmps=_svs.components=_svs.components||{};
_cmps.dimmer=_cmps.dimmer||{};
_cmps.dimmer.templates=_cmps.dimmer.templates||{};
svs.components.dimmer.templates.dimmer = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"js-dimmer dimmer\"></div>";
},"useData":true});
Handlebars.partials['components-components-dimmer-dimmer'] = svs.components.dimmer.templates.dimmer;
})(svs, Handlebars);

 })(window);